import { HEADER } from "../content/copy";
import { SignalMeter } from "./fx/SignalMeter";

export const scrollToId = (id) => {
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  document.getElementById(id)?.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
};

export const Header = () => (
  <header className="site-header" data-testid="site-header">
    <div className="site-header-inner">
      <div className="header-brand mono" data-testid="header-brand">
        <span className="status-dot" aria-hidden="true" />
        <span>{HEADER.brand}</span>
      </div>
      <SignalMeter />
      <button
        type="button"
        className="btn-header mono"
        onClick={() => scrollToId("finestra-30-secondi")}
        data-testid="header-resume-choice-btn"
      >
        {HEADER.cta}
      </button>
    </div>
  </header>
);
